import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button, Image } from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./VCardV.css";
import FileSaver from "file-saver";

function VCardV() {
  const [response, setResponses] = useState([]);
  const responseId = useParams();
  const navigate = useNavigate();

  const getResponse = async () => {
    const res = await axios.get(`/api/vcard/${responseId.id}/`);
    setResponses(res.data);
    console.log(res.data);
  };

  useEffect(() => {
    getResponse();
  }, []);

  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const downloadVCard = (e) => {
    e.preventDefault();
    var vCardContent = `BEGIN:VCARD
VERSION:3.0
N:${response.lName || ""};${response.fName || ""};;;
FN:${response.fName || ""} ${response.lName || ""}`;

    if (response.company) {
      vCardContent += `\nORG:${response.company}`;
    }

    if (response.job) {
      vCardContent += `\nTITLE:${response.job}`;
    }

    if (response.email) {
      vCardContent += `\nEMAIL;type=pref:${response.email}`;
    }

    if (response.mobile1) {
      vCardContent += `\nTEL;type=CELL;type=VOICE;type=pref:${response.mobile1}`;
    }

    if (response.mobile2) {
      vCardContent += `\nTEL;type=CELL;type=VOICE;type=pref:${response.mobile2}`;
      vCardContent += `\nX-SOCIALPROFILE;type=whatsapp:${response.mobile2}`;
    }

    if (response.mobile3) {
      vCardContent += `\nTEL;type=CELL;type=VOICE;type=pref:${response.mobile3}`;
    }

    if (response.website) {
      vCardContent += `\nURL:${response.website}`;
    }

    if (
      response.addDoorNum ||
      response.addStreet ||
      response.addCity ||
      response.addZip ||
      response.addState ||
      response.addCountry
    ) {
      vCardContent += `\nADR;type=HOME;type=pref:;;;${
        response.addDoorNum || ""
      }, ${response.addStreet || ""}, ${response.addCity || ""}, ${
        response.addZip || ""
      }, ${response.addState || ""}, ${response.addCountry || ""}`;
    }

    vCardContent += `
END:VCARD`;

    var file = new Blob([vCardContent], { type: "text/vcard;charset=utf-8" });

    let a = document.createElement("a");
    a.download = `${response.fName} ${response.lName}.vcf`;
    a.href = URL.createObjectURL(file);
    var reader = new FileReader();
    if (navigator.userAgent.match("CriOS")) {
      reader.onloadend = (e) => {
        window.open(reader.result);
      };
      reader.readAsDataURL(file);
    } else if (navigator.userAgent.match(/iPad|iPhone|Android/i)) {
      reader.onload = (e) => {
        window.location.href = reader.result;
      };
      reader.readAsDataURL(file);
    } else {
      FileSaver.saveAs(file, `${response.fName} ${response.lName}.vcf`, true);
    }
  };

  const mapLink = `https://google.com/maps/search/${response.addDoorNum},+${response.addStreet},+${response.addCity},+${response.addZip},+${response.addState},+${response.addCountry}`;

  return (
    <div className="qrView">
      <div className="lgScreenBg">
        <div
          className="viewTop"
          style={{
            backgroundColor: `${"#1b0861"}`,
            color: `${response.tTextColor}`,
          }}
        >
          <Row className="topContainer">
            <div className="phoneBoxT">
              <div className="screenView">
                <div
                  className="ctcView-top"
                  style={{
                    backgroundColor: `${"#1b0861"}`,
                    color: `${response.tTextColor}`,
                  }}
                >
                  {response.profilePic ? (
                    <Row>
                      <Col xs={4}>
                        <Image
                          className="ctcView-image"
                          src={response.profilePic}
                          fluid
                        />
                      </Col>
                      <Col xs={8}>
                        <Row className="d-flex align-items-center">
                          <p className="ctcView-name">{response.name}</p>
                        </Row>
                        <Row className="d-flex align-items-center">
                          <p className="ctcView-job">{response.job}</p>
                        </Row>
                        <Row>
                          <p className="ctcView-about">{response.about}</p>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        <Row className="d-flex align-items-center">
                          <p className="ctcView-name">{response.name}</p>
                        </Row>
                        <Row className="d-flex align-items-center">
                          <p className="ctcView-job">{response.job}</p>
                        </Row>
                        <Row>
                          <p className="ctcView-about">{response.about}</p>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </div>
                <div className="ctcView-mid">
                  <Row
                    className="justify-content-md-start"
                    style={{
                      width: "100%",
                      margin: "0px",
                      backgroundColor: `${"#1b0861"}`,
                    }}
                  >
                    {response.mobile1 ? (
                      <Col className="ctcView-icons-col">
                        <a target="_blank" href={`tel:${response.mobile1}`}>
                          <p className="ctcView-icons">
                            <i className="fa-solid fa-phone"></i>
                          </p>
                        </a>
                      </Col>
                    ) : null}
                    {response.email ? (
                      <Col className="ctcView-icons-col">
                        <a target="_blank" href={`mailto:${response.email}`}>
                          <p className="ctcView-icons-mid">
                            <i className="fa-regular fa-envelope"></i>
                          </p>
                        </a>
                      </Col>
                    ) : null}
                    {response.addCity ? (
                      <Col className="ctcView-icons-col">
                        <a href={mapLink} target="_blank">
                          <p className="ctcView-icons">
                            <i className="fa-solid fa-location-dot"></i>
                          </p>
                        </a>
                      </Col>
                    ) : null}
                  </Row>
                </div>
              </div>
            </div>
          </Row>
        </div>
        <div className="viewBottom">
          <Row className="bottomContainer" style={{ paddingBottom: "6em" }}>
            <div className="phoneBoxB">
              <div className="ctcView-bottom">
                <Row>
                  <div className="ctcView-section">
                    {response.mobile1 ? (
                      <a target="_blank" href={`tel:${response.mobile1}`}>
                        <Row>
                          <Col xs={3}>
                            <p
                              className="ctcView-side-icons"
                              style={{ color: "#1b0861" }}
                            >
                              <i className="fa-solid fa-phone"></i>
                            </p>
                          </Col>
                          <Col>
                            <div className="ctcView-textBox">
                              <p className="ctcView-text">{response.mobile1}</p>
                              <p className="ctcView-subhead">Mobile Number</p>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    ) : null}

                    {response.mobile2 ? (
                      <a
                        target="_blank"
                        href={`https://wa.me/${response.mobile2}`}
                      >
                        <Row>
                          <Col xs={3}>
                            <a
                              target="_blank"
                              href={`https://wa.me/${response.mobile2}`}
                            >
                              <p
                                className="ctcView-side-icons"
                                style={{ color: "#1b0861" }}
                              >
                                <i className="fa-brands fa-whatsapp"></i>
                              </p>
                            </a>
                          </Col>
                          <Col>
                            <div className="ctcView-textBox">
                              <p className="ctcView-text">{response.mobile2}</p>
                              <p className="ctcView-subhead">Whatsapp Number</p>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    ) : null}
                    {response.mobile3 ? (
                      <a target="_blank" href={`tel:${response.mobile3}`}>
                        <Row>
                          <Col xs={3}>
                            <p
                              className="ctcView-side-icons"
                              style={{ color: "#1b0861" }}
                            >
                              <i className="fa-solid fa-phone"></i>
                            </p>
                          </Col>
                          <Col>
                            <div className="ctcView-textBox">
                              <p className="ctcView-text">{response.mobile3}</p>
                              <p className="ctcView-subhead">Mobile Number</p>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    ) : null}
                    {response.fax ? (
                      <Row>
                        <Col xs={3}>
                          <p
                            className="ctcView-side-icons"
                            style={{ color: "#1b0861" }}
                          >
                            <i className="fa-solid fa-fax"></i>
                          </p>
                        </Col>
                        <Col>
                          <div className="ctcView-textBox">
                            <p className="ctcView-text">{response.fax}</p>
                            <p className="ctcView-subhead">Fax</p>
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                  </div>
                  {response.email ? (
                    <div className="ctcView-section">
                      <a target="_blank" href={`mailto:${response.email}`}>
                        <Row>
                          <Col xs={3}>
                            <p
                              className="ctcView-side-icons"
                              style={{ color: "#1b0861" }}
                            >
                              <i className="fa-regular fa-envelope"></i>
                            </p>
                          </Col>
                          <Col>
                            <div className="ctcView-textBox">
                              <p className="ctcView-text">{response.email}</p>
                              <p className="ctcView-subhead">Email Address</p>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    </div>
                  ) : null}
                  {response.company ? (
                    <div className="ctcView-section">
                      <Row>
                        <Col xs={3}>
                          <p
                            className="ctcView-side-icons"
                            style={{ color: "#1b0861" }}
                          >
                            <i className="fa-solid fa-user"></i>
                          </p>
                        </Col>
                        <Col>
                          <div className="ctcView-textBox">
                            <p className="ctcView-text">{response.company}</p>
                            <p className="ctcView-subhead">{response.job}</p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : null}
                  {response.website ? (
                    <div className="ctcView-section">
                      <a target="_blank" href={`https://${response.website}/`}>
                        <Row>
                          <Col xs={3}>
                            <p
                              className="ctcView-side-icons"
                              style={{ color: "#1b0861" }}
                            >
                              <i className="fa-solid fa-globe"></i>
                            </p>
                          </Col>
                          <Col>
                            <div className="ctcView-textBox">
                              <p className="ctcView-text">{response.website}</p>
                              <p className="ctcView-subhead">Website</p>
                            </div>
                          </Col>
                        </Row>
                      </a>
                    </div>
                  ) : null}
                  {response.addDoorNum ||
                  response.addStreet ||
                  response.addCity ||
                  response.addZip ||
                  response.addState ||
                  response.addCountry ? (
                    <div className="ctcView-section">
                      <Row>
                        <Col xs={3}>
                          <p
                            className="ctcView-side-icons"
                            style={{ color: "#1b0861" }}
                          >
                            <i className="fa-solid fa-location-dot"></i>
                          </p>
                        </Col>
                        <Col>
                          <div className="ctcView-textBox">
                            <p className="ctcView-text">
                              {response.addDoorNum}, {response.addStreet},{" "}
                              {response.addCity} - {response.addZip},{" "}
                              {response.addState}, {response.addCountry}
                            </p>
                            <p className="ctcView-subhead">Address</p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : null}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      className="btn--outline"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      onClick={downloadVCard}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      SAVE CONTACT
                    </Button>
                  </div>
                </Row>
              </div>
            </div>
          </Row>
        </div>
      </div>
      <div>
        <h4
          style={{ textAlign: "center", marginBottom: "40px", color: "#000" }}
        >
          Want a Your Own QR Code for free?{" "}
          <Button
            className="btn--secondary--dark"
            onClick={() => navigate("/signup")}
          >
            Click here
          </Button>
        </h4>
      </div>
    </div>
  );
}

export default VCardV;
